import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles/App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Страницы
import Manual from './pages/Manual';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Refund from './pages/Refund';
import Download from './pages/Download';
import Profile from './pages/Profile';
import MainPage from './pages/MainPage';
import News from './pages/News';

import DiamondVPNService from './services/api';
import DiamondBackground from './components/DiamondBackground';
import { i18n } from './utils/i18n';
import SupportChat from './components/SupportChat';

function App() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const location = useLocation();
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50
    });

    const urlParams = new URLSearchParams(window.location.search);
    const rawReferrerId = urlParams.get('ref');
    const referrerId = rawReferrerId && /^\d+$/.test(rawReferrerId) ? rawReferrerId : null;
    const existingReferrerId =
      localStorage.getItem('referrer_id') || sessionStorage.getItem('referrer_id');
    if (referrerId && (!existingReferrerId || existingReferrerId === 'undefined' || existingReferrerId === 'null')) {
      localStorage.setItem('referrer_id', referrerId);
      sessionStorage.setItem('referrer_id', referrerId);
    }

    checkAuthentication();

    setIsInitialized(true);

    AOS.refresh();
  }, [location]);

  const checkAuthentication = async () => {
    try {
      const authStatus = await DiamondVPNService.checkAuth();
      setIsAuthenticated(authStatus);
      if (authStatus) {
        localStorage.removeItem('referrer_id');
        sessionStorage.removeItem('referrer_id');
        try {
          const { language } = await DiamondVPNService.getUserLanguage();
          if (language && language !== i18n.getLanguage()) {
            i18n.changeLanguage(language);
          }
        } catch (e) {
          console.warn('Failed to sync user language:', e);
        }
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setAuthChecked(true);
    }
  };

  const handlePlanSelect = useCallback((plan) => {
    setSelectedPlan(plan);

  }, []);

  if (!isInitialized || !authChecked) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Загрузка Diamond VPN...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <DiamondBackground />
      <Header isAuthenticated={isAuthenticated} />
      <Routes>
        <Route 
          path="/" 
          element={
            <MainPage 
              onPlanSelect={handlePlanSelect}
              selectedPlan={selectedPlan}
              isAuthenticated={isAuthenticated}
            />
          } 
        />
        <Route path="/manual" element={<Manual />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/download" element={<Download />} />
        <Route path="/news" element={<News />} />
        <Route path="/refund" element={<Refund />} />
      </Routes>
      <SupportChat isAuthenticated={isAuthenticated} />
      <Footer />
    </div>
  );
}

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
